module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary-section",
    attrs: {
      "data-aos": _vm.isInternalView ? '' : 'fade-up',
      "data-aos-once": "true"
    }
  }, [_c('v-container', [_c('v-expansion-panels', {
    attrs: {
      "dark": "",
      "accordion": "",
      "multiple": ""
    },
    model: {
      value: (_vm.panel),
      callback: function($$v) {
        _vm.panel = $$v
      },
      expression: "panel"
    }
  }, [_c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-header', [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Story Analysis Summary")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "primary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 4269816174)
  }) : _vm._e(), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": _vm.downloadSummary
    }
  }, [_c('i', {
    staticClass: "fas fa-download fa-lg",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Download"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isInternalView && _vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('open-analysis')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-magic fa-lg",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "AI Analysis"
    }
  })]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "id": "story-analysis-summary",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', [(_vm.groups.length > 0) ? _c('div', {
    staticClass: "group-filter-btns-right"
  }, [_c('div', {
    staticClass: "group-btns"
  }, _vm._l((_vm.groups), function(group) {
    return _c('v-btn', {
      key: group.groupID,
      class: ['group-btn', {
        'active-btn': _vm.selectedGroup === group.groupID
      }],
      staticStyle: {
        "margin-right": "8px",
        "color": "#212121"
      },
      attrs: {
        "color": _vm.selectedGroup === group.groupID ? 'orange' : '#fff',
        "depressed": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.selectedGroup = _vm.selectedGroup === group.groupID ? null : group.groupID
        }
      }
    }, [_vm._v("\n                      " + _vm._s(group.groupName || group.groupID) + "\n                    ")])
  }), 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right mb-2"
  }, [(_vm.editPostOrder) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.cancelPostOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n                    Cancel\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.editPostOrder) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "success",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.savePostOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-content-save")]), _vm._v(" Save Changes\n                  ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    directives: [{
      name: "sortable-data-table",
      rawName: "v-sortable-data-table"
    }],
    key: _vm.dataTableKey,
    staticClass: "elevation-15 report-summary-table",
    attrs: {
      "dark": "",
      "headers": _vm.computedHeaders,
      "items": _vm.filteredItems,
      "item-key": "key",
      "items-per-page": -1,
      "custom-sort": _vm.customSort
    },
    on: {
      "sorted": _vm.handleDataTableDragDrop
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h
            }
          })]
        }
      }
    }), {
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "d-flex align-center"
        }, [_c('v-icon', {
          staticClass: "move-cursor",
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n                        mdi-arrow-all\n                      ")]), _vm._v(" "), (_vm.isInternalView) ? _c('v-btn', {
          staticClass: "btn-reload",
          attrs: {
            "text": "",
            "x-small": "",
            "color": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.refreshReportInf(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": "",
            "small": ""
          }
        }, [_vm._v("\n                          mdi-reload\n                        ")])], 1) : _vm._e(), _vm._v(" "), _c('a', {
          staticClass: "caption",
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "href": _vm.profileUrl(item),
            "target": "_blank",
            "rel": "noopener noreferrer"
          }
        }, [_vm._v("@" + _vm._s(item.profileHandle || item.name))])], 1)]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 || !item.outreach ? '-' : item.outreach)) + "\n                  ")]
      }
    }, {
      key: "item.shares",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.shares === 0 ? '-' : item.shares)) + "\n                  ")]
      }
    }, {
      key: "item.replies",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.replies === 0 ? '-' : item.replies)) + "\n                  ")]
      }
    }, {
      key: "item.link_clicks",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.link_clicks === 0 ? '-' : item.link_clicks)) + "\n                  ")]
      }
    }, {
      key: "item.sticker_taps",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.sticker_taps === 0 ? '-' : item.sticker_taps)) + "\n                  ")]
      }
    }, {
      key: "item.reach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.reach === 0 ? '-' : item.reach)) + "\n                  ")]
      }
    }, {
      key: "item.impressions",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.impressions === 0 ? '-' : item.impressions)) + "\n                  ")]
      }
    }, {
      key: "item.story_likes",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.story_likes === 0 ? '-' : item.story_likes)) + "\n                  ")]
      }
    }, {
      key: "item.interactions",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.interactions === 0 ? '-' : item.interactions)) + "\n                  ")]
      }
    }, {
      key: "item.new_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.new_engagement_rate === 0 || !item.new_engagement_rate ? '-' : item.new_engagement_rate)) + "\n                  ")]
      }
    }, {
      key: "item.avg_views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.avg_views === null ? '-' : item.avg_views)) + "\n                  ")]
      }
    }, {
      key: "item.avg_reels_plays",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.avg_reels_plays === null ? '-' : item.avg_reels_plays)) + "\n                  ")]
      }
    }], null, true)
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("TOTAL")])]), _vm._v(" "), _vm._l((_vm.computedHeaders), function(header) {
    return [(header.value !== 'name') ? _c('td', {
      key: header.value
    }, [_c('strong', [(header.value === 'live_date') ? [_vm._v("-")] : (header.value === 'outreach') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalOutreach === 0 ? '-' : _vm.totalOutreach)))] : (header.value === 'reach') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalReach === 0 ? '-' : _vm.totalReach)))] : (header.value === 'impressions') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalImpressions === 0 ? '-' : _vm.totalImpressions)))] : (header.value === 'story_likes') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalStoryLikes === 0 ? '-' : _vm.totalStoryLikes)))] : (header.value === 'replies') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalReplies === 0 ? '-' : _vm.totalReplies)))] : (header.value === 'shares') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalShares === 0 ? '-' : _vm.totalShares)))] : (header.value === 'link_clicks') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalLinkClicks === 0 ? '-' : _vm.totalLinkClicks)))] : (header.value === 'sticker_taps') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalStickerTaps === 0 ? '-' : _vm.totalStickerTaps)))] : (header.value === 'interactions') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalInteractions === 0 ? '-' : _vm.totalInteractions)))] : (header.value === 'new_engagement_rate') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalNewEngagementRate === 0 ? '-' : _vm.totalNewEngagementRate)))] : (header.value === 'avg_views') ? [_vm._v("-")] : (header.value === 'avg_reels_plays') ? [_vm._v("-")] : _vm._e()], 2)]) : _vm._e()]
  })], 2)])], 2)], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Story Analysis Summary",
      "items": _vm.tableColsItems,
      "isSort": true
    },
    on: {
      "updated": _vm.updateStoryAnalysisStatus
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d22c403"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/StorySummary.vue
// module id = 2087
// module chunks = 0